<template>
    <!--show this button only on non-super admin-->
  <BaseTableItemAction
    v-can:[editPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-pencil"
    actionName="تعديل"
    v-if="item.id!=1"
    :to="'/admins/' + item.id + '/edit'"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_ADMINS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      editPermission: WRITE_ADMINS_PERMISSION,
    };
  },
};
</script>
